import { Routes } from "@angular/router";

export const routes: Routes = [
	{
		path: "**",
		loadComponent: () =>
			import("./_shared/components/prop65-moved-maintenance-page/prop65-moved-maintenance-page.component").then((c) => c.Prop65MovedMaintenancePageComponent),
	},
];
